import type { WireArticleBlock } from '../../../api/types'

type Block = Extract<WireArticleBlock, { type: 'source-list' }>

export function SourceListBlock({ block }: { block: Block }) {
  if (!block.entries.length) return null

  return (
    <div className="border-t border-line pt-6">
      <p className="mb-3 text-[10px] font-bold uppercase tracking-[0.22em] text-fg-secondary">
        Sources
      </p>
      <ol className="list-decimal space-y-2 pl-5">
        {block.entries.map((e) => (
          <li key={e.id} className="text-sm text-fg-secondary">
            {e.text}
          </li>
        ))}
      </ol>
    </div>
  )
}
